function getConfig(key, fallback) {
  return window.CONFIG?.[key] ?? process.env?.[key] ?? fallback
}

export const ROOMS_API_URL = getConfig('ROOMS_API_URL', 'http://localhost:3000')

export const USB_API_URL = getConfig(
  'USB_API_URL',
  'https://api.usb.urbanobservatory.ac.uk/api/v2.0a'
)
